import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { AxiosResponse } from "axios";
import { IUser } from "./types/_user";
const api = new APIClient();

const path = "/users";
const sp_path = "/sp-users";

const userApi = {
  spUsers(params: any): Promise<any> {
    const url = `${sp_path}`;
    return api.get(url, params);
  },

  spUsersDetail(id: any, params: any): Promise<any> {
    const url = `${sp_path}/${id}`;
    return api.get(url, params);
  },

  courseUser(params: any): Promise<any> {
    const url = `${"courses/purchased"}`;
    return api.get(url, params);
  },

  spUsersCountries(params: any): Promise<any> {
    const url = `${sp_path}/countries`;
    return api.get(url, params);
  },

  users(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  createUser(params: any) {
    return api.post(path, params);
  },

  updateUser(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deleteUser(
    id: string | number,
    dataForm?: any
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/${id}`;
    return api.delete(url, dataForm);
  },

  postUser(dataForm: any): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putUser(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  getUser(
    id: string | number,
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },

  putProfiles(dataForm: any): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/me/profile`;
    return api.put(url, dataForm);
  },

  getDeletedUsers(
    params: any
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/deleted-users`;
    return api.get(url, params);
  },

  userProfile(): Promise<any> {
    const url = `${path}/me`;
    return api.get(url);
  },
};

export default userApi;
